/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxWaterDropIcon20Solid = forwardRef('NatureFxWaterDropIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.07 1.72a1.337 1.337 0 0 1 1.86 0c.71.685 2.205 2.2 3.528 4.026C15.757 7.537 17 9.774 17 11.875a7 7 0 1 1-14 0c0-2.1 1.243-4.338 2.542-6.13C6.865 3.922 8.36 2.406 9.07 1.722Zm5.242 10.155c0-1.129-1.75-1.129-1.75 0 0 1.418-1.234 2.618-2.666 2.56-1.127-.045-1.198 1.703-.07 1.749 2.41.098 4.486-1.922 4.486-4.309Z" })));
});
